<loading-overlay [show]="isBusy">
    <div class="content">
        <div class="row">
            <h1>Contactar:</h1><p>{{data.name}}</p>
        </div>
        <hr />
        <div class="row">
            <div class="column">
                <h1>Mensaje:</h1>
                <textarea readonly class="message">{{data.message}}</textarea>
            </div>
        </div>
        <hr />
        <div class="row button-row">
            <button class="btn btn-light" (click)="cancel($event)">Cancelar</button>
            <button class="btn btn-primary" (click)="sendMessage($event)">Enviar</button>
        </div>
    </div>
</loading-overlay>
